import React from 'react';
import InfoGrid from "../../../../../../../components/info-grid/info-grid.jsx";

const IndividualPhysical = ({item}) => {
    const region = item.individualRegionWrapper ?? []
    if (!region.length || !region) return null;

    return (
        <>
            { region && (
                <section className="space-y-4!">
                    <div className={`text-[16px] mt-7! font-semibold text-[#4F4F4F] mb-2 print:break-after-avoid!`}>
                        Características físicas detalhadas
                    </div>

                    { region.map((item, index) => {

                        const info = [
                            {
                                label: "Local",
                                value: item?.local ?? "",
                            },
                            {
                                label: "Tipo",
                                value: item?.type ?? "",
                            },
                            {
                                label: "Descrição",
                                value: item?.description ?? ""
                            }
                        ];

                        return (
                            <>
                                <InfoGrid key={`${index}`} title={""} items={info} columns={3} labelClassName="text-[#4F4F4F] text-[13px]! print:text-[15px]!" valueClassName={'print:text-[17px]!'} className={'px-0!'} contentClassName={'space-y-1'}/>
                            </>
                        )

                    })}
                </section>
            )}
        </>
    );
};

export default IndividualPhysical;